import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import {
  map,
  takeUntil,
  first,
  startWith,
  distinctUntilChanged,
} from 'rxjs/operators';
import {
  AlgConsensoService,
  REQUEST_STATUS_INVALID,
  REQUEST_STATUS_OK,
} from '../../services/alg-consenso.service';
import { TitleType, ContractType, BillingFrequency , BillingFrequencyCustomerInfo, BillingFrequencySupplyInfo } from '../../models/billingFrequency';

@Component({
  selector: 'alg-billing-frequency',
  templateUrl: './alg-billing-frequency.component.html',
  styleUrls: ['./alg-billing-frequency.component.scss']
})
export class AlgBillingFrequencyComponent implements OnInit {
  private ngUnsubscribe = new Subject<void>();
  private routeParams$: Observable<Object>;
  public isLoading$: Observable<boolean>;
  public isErrorGeneric$: Observable<boolean>;
  public isRequestOk$: Observable<boolean>;
  public billingFrequency: BillingFrequency = {} as BillingFrequency;
  public customerInfo: BillingFrequencyCustomerInfo = {} as BillingFrequencyCustomerInfo;
  public supplyInfo: BillingFrequencySupplyInfo = {} as BillingFrequencySupplyInfo;
  public supplyType: string;
  public isConsents: boolean;
  public idRichiesta: string;
  public typeRichiesta: string;
  public codeRichiesta: string;
  public temporaryUrl: string;


  constructor(
    private activatedRoute: ActivatedRoute,
    private consensoService: AlgConsensoService,
  ) {
    this.routeParams$ = this.activatedRoute.params.pipe(
      map((params) => params && params)
    );

    this.isLoading$ = this.consensoService.isLoading$
  }

  ngOnInit() {      
    this.activatedRoute.queryParams.subscribe((params) => {
      this.temporaryUrl = window.location.href;
      this.idRichiesta = params.id;
      this.codeRichiesta = params.codice;
      this.typeRichiesta = this.temporaryUrl.includes('Luce&Gas')
        ? 'Luce&Gas'
        : params.tipo;
    });

    this.consensoService.fetchBillingFrequency(this.idRichiesta,
      this.codeRichiesta,
      this.typeRichiesta);
    this.consensoService.billingFrequencyRequest$
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((request) => {
        this.billingFrequency = request;
        this.supplyType = request.requestType;
        this.customerInfo.FirstName = request.FirstName;
        this.customerInfo.LastName = request.LastName;
        this.customerInfo.fiscalCode = request.fiscalCode;
        this.supplyInfo.frequency = request.billingFrequency;
        this.supplyInfo.PDR = request.PDR;
        this.supplyInfo.POD = request.POD;
      });

      this.consensoService.isOtpBillingFrequencyRequest$.subscribe((value) => {
        this.isConsents = value;
      });

      this.isRequestOk$ = this.consensoService.billingFrequencyRequestStatus$.pipe(
        map((request) => request === REQUEST_STATUS_OK),
        startWith(false),
        distinctUntilChanged()
      );

      this.isErrorGeneric$ = this.consensoService.billingFrequencyRequestStatus$.pipe(
        map((request) => { 
          return request === REQUEST_STATUS_INVALID}),
        startWith(false),
        distinctUntilChanged()
      );
  };

  public setBodyTitle(type) {
    if (type === ContractType.monoLight) {
      return TitleType.monoLight;
    } else if (type === ContractType.monoGas) {
      return TitleType.monoGas;
    } else {
      return TitleType.dual;
    };
  };

};



// WEBPACK FOOTER //
// ./src/app/pages/alg-billing-frequency/alg-billing-frequency.component.ts